<script setup lang="ts">
import dayjs from 'dayjs'

import type { Icons } from '@/components/base/BaseIcon.vue'

const { locale } = useI18n()

const props = withDefaults(
  defineProps<{
    icon?: Icons
    iconColor?: string
    occurredAt: string
    showConnector?: boolean
  }>(),
  {
    iconColor: 'bg-primary',
    showConnector: true
  }
)

const formatDate = (dateString: string) => {
  return dayjs(dateString).locale(locale.value).format('DD/MM/YYYY')
}

const formatTime = (dateString: string) => {
  return dayjs(dateString).locale(locale.value).format('HH:mm')
}

const resolvedIconColor = computed(() => {
  return props.iconColor || 'bg-foreground-disabled'
})
</script>

<template>
  <div class="relative py-4">
    <span v-if="showConnector" class="absolute left-4 top-4 -ml-px h-full w-0.5 bg-stone-200" aria-hidden="true" />
    <div class="relative flex space-x-3 items-center">
      <div>
        <span
          v-if="icon"
          class="flex h-8 w-8 items-center justify-center rounded-full ring-8 ring-white"
          :class="resolvedIconColor"
        >
          <BaseIcon :name="icon" class="h-5 w-5 text-white" />
        </span>
        <span
          v-else
          class="flex h-8 w-8 items-center justify-center rounded-full ring-8 ring-white bg-foreground-disabled"
        >
        </span>
      </div>
      <div class="flex min-w-0 flex-1 justify-between space-x-4">
        <div class="flex min-w-0 flex-1 flex-col items-start justify-center">
          <slot name="title">
            <p class="text-sm font-medium text-foreground"></p>
          </slot>
          <slot name="description">
            <p class="mt-1 text-sm text-muted-foreground"></p>
          </slot>
          <slot name="meta"></slot>
        </div>
        <div class="whitespace-nowrap text-right text-sm text-muted-foreground">
          <slot name="date">
            <div>{{ formatDate(occurredAt) }}</div>
            <div>{{ formatTime(occurredAt) }}</div>
          </slot>
        </div>
      </div>
    </div>

    <slot name="footer" />
  </div>
</template>
